import { Box, Container } from '@mui/material'
import Progress from '../Progress'


  const RequestBase = () => {
  return (
    <Box>
      <Container maxWidth="xl">
        <Progress />
      </Container>
    </Box>
  )
}


export default RequestBase
